// extracted by mini-css-extract-plugin
export default {"panel":"panel§Sa0zX5Z0J0Q1iZ7rrpgq","alert":"alert§x_t76OufcAEoVXuPB4gy"};